import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

// services
import { OpportunityViewService } from '@app/opportunities/services/opportunity-view.service';

@Component({
  selector: 'dgx-opportunity-not-found',
  templateUrl: './opportunity-not-found.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpportunityNotFoundComponent {
  public isLoading = true;
  // our crop of translated text
  public i18n = this.translateService.instant([
    'Opportunities_NotFound_DescriptionText',
    'Core_NotFound_HeaderText',
    'Opportunities_BrowseOpportunities',
  ]);
  public navigationUrl: string;
  constructor(
    private activeRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private opportunityViewService: OpportunityViewService,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.opportunityViewService.updatePageTitle(
      this.translateService.instant('Core_Opportunity')
    );
  }

  public ngOnInit(): void {
    this.navigationUrl = '/career/opportunities';
    // Redirect to our new router, if the path matches our old pattern.
    const matches = this.activeRoute.snapshot?.fragment?.match(
      /\/opportunity\/([0-9]+)/i
    );
    if (matches?.[1]) {
      this.router.navigateByUrl(`/opportunities/${matches[1]}/`);
      return;
    }
    // Otherwise, do nothing: we've reached this Not Found page legitimately.
    this.isLoading = false;
    this.cdr.markForCheck();
  }
}
